import GrainIcon from '@material-ui/icons/Grain';
import ReorderIcon from '@material-ui/icons/Reorder';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Errored from '../../core/Errored';
import Loading from '../../core/Loading';
import { makeCancelable, sortObjects } from '../../core/utils/utils';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';
import { Typography } from '@material-ui/core';

const styles = {
  linkJump: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#eee'
    }
  }
};

const loadOptions = {};

class CollectionSelector extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      taxonomies: null,
      collections: null,
      isErrored: null
    };
    this.cancellable = null;
  }

  static getDerivedStateFromProps(props, state) {
    // We use the objects internal version counter set by GS to know if changed
    if (props.data._version !== state._version) {
      return {
        collections: null,
        isLoading: true,
        _version: props.data._version,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.isErrored && this.props.data.hasComponent && this.state.collections === null) {
      this.collectComponentData();
    }
  }

  componentDidMount() {
    this.collectComponentData();
  }

  loadData(iris, options) {
    this.cancellable = makeCancelable(GS.loadData(iris, options, this.props.graph));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  collectComponentData() {
    if (this.props.data.hasComponent) {
      // At some point we want to filter the properties loaded for each component
      this.loadData(this.props.data.hasComponent, loadOptions)
        .promise
        .then(() => {
          this.processComponents();
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isLoading: false });
        })
        .catch((e) => {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        });
    }
    else {
      this.setState({ isLoading: false });
    }
  }

  processComponents() {
    let collections = [];
    let collectionsExist = false;
    this.props.data.hasComponent.forEach(component => {
      const componentData = GS.data(component, this.props.graph);
      const memberProp = componentData.type.includes("OrderedCollection") ? "memberList" : "member";
      if (componentData.type.includes("OrderedCollection") || componentData.type.includes("Collection")) {
        collectionsExist = true;
        if (!componentData[memberProp] || !componentData[memberProp].includes(this.props.conceptIRI)) {
          collections.push({
            id: componentData.id,
            title: componentData.title,
            type: componentData.type,
            description: componentData.description
          });
        }
      }
    });
    sortObjects(collections, 'title', this.props.defaultLang, null, false);
    this.setState({ collections, collectionsExist });
  }

  render() {

    const { classes, onSelectCollection } = this.props;
    const defaultLang = this.props.data.defaultLang;
    const { collections, isLoading, isErrored, collectionsExist } = this.state;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoading) return <Loading />;
    if (collections.length === 0) {
      if (collectionsExist) {
        return <Typography data-test="collection-info" variant="body2">Concept is already in all project collections.</Typography>;
      }
      else return <Typography data-test="collection-info" variant="body2">No collections are available.</Typography>;
    }

    return (
      <List data-test="collection-list" style={{ maxHeight: 500 }}>
        {collections.map((collection) =>
          <ListItem key={collection.id} className={classes.linkJump} onClick={() => onSelectCollection(collection.id)}>
            <ListItemIcon className={classes.resultIcon}>
              {
                collection.type.includes("OrderedCollection") ?
                  <ReorderIcon fontSize="small" />
                  :
                  <GrainIcon fontSize="small" />
              }
            </ListItemIcon>
            <ListItemText primary={collection.title ?
              (collection.title[defaultLang] ?
                collection.title[defaultLang]
                :
                collection.id)
              :
              collection.id
            }
              secondary={collection.description ? collection.description[defaultLang] : ""} />
          </ListItem>
        )}
      </List>
    );
  }
}

CollectionSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  conceptIRI: PropTypes.string.isRequired,
  onSelectCollection: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(CollectionSelector));


